export const SCORE_BOX_TRANSLATIONS = {
  en: {
    SCORE_BOX_TITLE: 'Score Analysis',
    SCORE_BOX_GENERATE_BUTTON: 'Generate Score Analysis',
    SCORE_BOX_ANALYZING: 'Analyzing…',
    SCORE_BOX_ORIGINAL_LABEL: 'Original',
    SCORE_BOX_DRAFT_LABEL: 'Draft',
    SCORE_BOX_SEO_LABEL: 'SEO',
    SCORE_BOX_GEO_LABEL: 'GEO',
    SCORE_BOX_READABILITY_LABEL: 'Readability',
    SCORE_BOX_UPGRADE_BUTTON: 'Upgrade to See Details',
    SCORE_BOX_UPGRADE_MESSAGE:
      'Upgrade your plan to access detailed score analysis with SEO, GEO, and Readability metrics.',
    SCORE_BOX_COMPARISON_TITLE: 'Score Comparison',
    SCORE_BOX_DISTRIBUTION_TITLE: 'Score Distribution',
    SCORE_BOX_IMPROVEMENT_TITLE: 'Improvement Analysis',
    SCORE_BOX_IMPROVE_BUTTON: 'Improve'
  },
  de: {
    SCORE_BOX_TITLE: 'Score-Analyse',
    SCORE_BOX_GENERATE_BUTTON: 'Score-Analyse generieren',
    SCORE_BOX_ANALYZING: 'Analysiere…',
    SCORE_BOX_ORIGINAL_LABEL: 'Original',
    SCORE_BOX_DRAFT_LABEL: 'Entwurf',
    SCORE_BOX_SEO_LABEL: 'SEO',
    SCORE_BOX_GEO_LABEL: 'GEO',
    SCORE_BOX_READABILITY_LABEL: 'Lesbarkeit',
    SCORE_BOX_UPGRADE_BUTTON: 'Upgrade für Details',
    SCORE_BOX_UPGRADE_MESSAGE:
      'Upgraden Sie Ihren Plan, um detaillierte Score-Analysen mit SEO-, GEO- und Lesbarkeits-Metriken zu erhalten.',
    SCORE_BOX_COMPARISON_TITLE: 'Score-Vergleich',
    SCORE_BOX_DISTRIBUTION_TITLE: 'Score-Verteilung',
    SCORE_BOX_IMPROVEMENT_TITLE: 'Verbesserungsanalyse',
    SCORE_BOX_IMPROVE_BUTTON: 'Verbessern'
  }
}
